import React, { useState, useRef } from "react";
import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { addFonction } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IFonctionState } from "./interface";


interface IAddProps {
  fonctionState: IFonctionState;
  setFonctionState: (x: IFonctionState) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    fonctionState, setFonctionState
  } = props



  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setFonctionState({ ...fonctionState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="libFonction"
            label="libellé fonction"
            value={fonctionState.libFonction}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>

    </Box>

  );
};


export const initialState = { libFonction: "" }

const DialogAdd = () => {


  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState(false)
  const [addLoading, setAddLoading] = useState(false)
  const [fonctionState, setFonctionState] = useState<any>({})

  //Fermer la boite de dialog d'ajout de fonction
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout de fonction
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer une fontion
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      const apiPayload = {
        fonctionAgent: fonctionState.libFonction
      }
      const res: any = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/ajouterfonction", apiPayload);
      if (res.status === 1) {
        dispatch(addFonction(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setFonctionState(initialState)
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:106 ~ handleSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          fonctionState={fonctionState}
          setFonctionState={setFonctionState}
        />}
      actionFunc={handleSave}
      title="Fonction"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



